import { T } from "../lib/types/common";
import { Member } from "../lib/types/member";
import api from "../lib/axiosInstance";

class MemberService {
  public async googleAuth(googleResponse: T): Promise<T> {
    try {
      const response = await api.post(`/auth/google`, {
        code: googleResponse.code,
      });

      return response.data;
    } catch (err) {
      console.log("Error, googleAuth:", err);
      throw err;
    }
  }

  public async githubAuth(code: string): Promise<T> {
    try {
      const response = await api.post(`/auth/github`, {
        code: code,
      });

      return response.data;
    } catch (err) {
      console.log("Error, githubAuth:", err);
      throw err;
    }
  }

  public async telegramAuth(data: any): Promise<T> {
    try {
      const response = await api.post(`/auth/telegram`, data);

      return response.data;
    } catch (err) {
      console.log("Error, telegramAuth:", err);
      throw err;
    }
  }

  public async authMe(token: string): Promise<Member> {
    try {
      const response = await api.get(`/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data;
    } catch (err) {
      console.log("Error, authMe:", err);
      throw err;
    }
  }

  public async logout(): Promise<Member> {
    try {
      const refreshToken = localStorage.getItem("refreshToken");

      const response = await api.post(`/auth/logout`, {
        refreshToken: refreshToken,
      });

      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");

      return response.data;
    } catch (err) {
      console.log("Error, logout:", err);
      throw err;
    }
  }

  public async refreshAccessToken(): Promise<string> {
    const localRefreshToken = localStorage.getItem("refreshToken");

    const response = await api.post(`/auth/refresh`, {
      refreshToken: localRefreshToken,
    });

    const { accessToken, refreshToken } = response.data;

    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);

    return accessToken;
  }
}

export default MemberService;
